import React from 'react';
import { AtSignIcon, FacebookIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'tuconexioneducativa@gmail.com',
  href: 'mailto:tuconexioneducativa@gmail.com'
}, {
  icon: AtSignIcon,
  label: 'Instagram: @Tuconexioneducativa',
  href: 'https://instagram.com/tuconexioneducativa'
}, {
  icon: FacebookIcon,
  label: 'Facebook: Tuconexioneducativa',
  href: 'https://facebook.com/tuconexioneducativa'
}];
export function Footer() {
  return <footer className="bg-night pb-28 lg:pb-14" data-id="element-73" data-mp="37o6cv1anxdd">
      <div className="mx-auto max-w-content px-6 pt-14" data-id="element-74" data-mp="36d3cxfoatnb">
        <p className="mx-auto max-w-lg text-center font-display text-2xl leading-snug text-gold-soft" data-id="element-75" data-mp="3ldkdj3f9yapl">
          “Lámpara es a mis pies tu palabra, y lumbrera a mi camino.”
        </p>
        <p className="mt-2 text-center font-sans text-sm text-parchment/55" data-id="element-76" data-mp="29yxc5agnxgkr">Salmo 119:105</p>

        <div className="mt-10 flex flex-col items-center gap-6 border-t border-night-line pt-8 md:flex-row md:justify-between" data-id="element-77" data-mp="2eyjs3rnvlax9">
          <ul className="flex flex-col items-center gap-3 font-sans text-sm md:flex-row md:gap-8" data-id="element-78" data-mp="3la2a6wqof7wa">
            {links.map(link => <li key={link.label} data-id="element-79" data-mp="3gctmyhqo8do6">
                <a href={link.href} className="inline-flex items-center gap-2 text-parchment/70 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-80" data-mp="3v7zvpch5iql7">
                  <link.icon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="81pgvn5hf5bh" />
                  {link.label}
                </a>
              </li>)}
          </ul>

          <p className="text-center font-sans text-xs leading-relaxed text-parchment/45 md:text-right" data-id="element-82" data-mp="hsk0skv99str">
            © Botiquín Espiritual 2026 — Todos los derechos reservados.
            <br data-id="element-83" data-mp="cw35n6pn2e76" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}